import { makeStyles } from '@material-ui/core';

export const styles = makeStyles({
    formRow: {
        // display: 'flex',
        borderBottom: '1.2px solid #eaeaea',
        alignItems: 'center',
        '& img, & svg': {
            // margin: '0 5px'
        },
        '& > div': {
            display: 'flex'
        }
    },
    formNameWrapper: (props) => ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        // minWidth: '100px',
        // width: '40%',
        // minHeight: '140px',
        padding: props.rtl ? '16px 0px 16px 16px' : '16px 16px 16px 0',
        position: 'relative'
    }),
    formFocus: {
        backgroundColor: 'rgba(192, 192, 192)'
    },
    optionRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start'
    },
    optionTitle: {
        // marginLeft: '4px',
        fontSize: '13px',
        color: '#416ce1',
        fontFamily: 'inherit',
        fontWeight: 'bold'
    },
    formName: {
        margin: '0 4px',
        fontSize: '15px',
        fontWeight: 'bold',
        wordBreak: 'break-word'
    },
    description: {
        fontSize: '13px',
        fontWeight: 'normal',
        marginTop: '8px',
        wordBreak: 'break-word'
    },
    overallInfo: {
        paddingInlineStart: '20px'
    },
    clinicsContainer: {
        display: 'flex',
        alignItems: 'center',
        flexFlow: 'wrap',
        marginTop: '20px'
    },
    clinic: {
        minWidth: '80px',
        padding: '6px 8px',
        background: '#e7ecf2',
        borderRadius: '4px',
        textAlign: 'center',
        fontSize: '12px',
        marginInlineEnd: '8px',
        marginTop: '8px'
    },
    moveIcon: {
        width: '20px',
        height: '20px'
    },
    ButtonContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '8px',
        '& > div': {
            minWidth: ({ rtl }) => (rtl ? '130px' : '155px'),
            maxWidth: '155px'
        },
        '& button': {
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
        },
        '& button svg': {
            marginInlineEnd: '6px',
            marginTop: '1px',
            width: '20px',
            height: '20px'
        }
    },
    option: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        '& div': {
            position: 'absolute',
            width: '100%',
            top: 0,
            height: '100%',
            opacity: '0'
        }
    },
    reportButton: {
        padding: '5px 3px',
        borderRadius: '6px',
        border: 'solid 1.5px #416ce1',
        backgroundColor: '#fff',
        fontFamily: 'inherit',
        fontSize: '12px',
        fontWeight: 'bold',
        lineHeight: 1.75,
        textAlign: 'center',
        color: '#416ce1',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#e7ecf2'
        },
        '&:disabled': {
            backgroundColor: '#fff',
            opacity: '0.5',
            color: '#416ce1'
        },
        '& img': {
            marginInlineEnd: '6px'
        }
    },
    addContainer: {
        minWidth: '110px',
        color: '#1b90fa',
        fontSize: '14px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '0 10px'
    },

    deleteFormLink: {
        color: '#ef1734',
        fontWeight: '500',
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
        padding: '0 5px',
        cursor: 'pointer'
    },
    clinicItem: {
        display: 'flex',
        backgroundColor: '#e8ecf2',
        borderRadius: '6px',
        padding: '5px 8px',
        margin: '0 6px',
        minWidth: '78px',
        justifyContent: 'space-between',
        '& img:hover, & svg:hover': {
            cursor: 'pointer'
        }
    },
    infoContainer: {
        maxWidth: '500px'
    },
    column: {
        display: 'flex',
        flexDirection: 'column'
    },
    row: {
        display: 'flex'
        // justifyContent: 'space-between'
    },
    dateWrapper: {
        marginTop: '10px',
        display: 'flex',
        '& span': {
            fontFamily: 'inherit',
            fontSize: '12px',
            fontWeight: 'normal',
            lineHeight: 1.75,
            color: '#545e66',
            marginInlineEnd: '8px'
        }
        // '& span:first-child': {
        //     marginInlineEnd: '8px'
        // }
    },
    createReport: {
        width: '190px',
        padding: '16px',
        borderRadius: '6px',
        boxShadow: '0 2px 8px 0 rgba(84, 94, 102, 0.12)',
        border: 'solid 1.5px #f5f8fa',
        backgroundColor: '#fff',
        textAlign: 'start',
        '& > *': {
            fontSize: '13px'
        }
    },
    radioWrapper: {
        display: 'flex',
        marginInlineStart: '-10px',
        '& label': {
            margin: '0'
        }
    },
    addClinic: {
        display: 'flex',
        alignItems: 'center',
        color: '#509ffa',
        marginTop: '6px',
        cursor: 'pointer',
        '& svg': {
            marginInlineEnd: '6px'
        }
    }
});
